/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const monitoringIntegrationVersionCommandExpectedVersionExclusiveMin = 0;
export const monitoringIntegrationVersionCommandExpectedVersionMax = 9007199254740991;

export const MonitoringIntegrationVersionCommand = zod.object({
  expectedVersion: zod
    .int()
    .gt(monitoringIntegrationVersionCommandExpectedVersionExclusiveMin)
    .max(monitoringIntegrationVersionCommandExpectedVersionMax),
});

export type MonitoringIntegrationVersionCommand = zod.input<
  typeof MonitoringIntegrationVersionCommand
>;
export type MonitoringIntegrationVersionCommandOutput = zod.output<
  typeof MonitoringIntegrationVersionCommand
>;
